
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook that scrolls to the top of the page on route changes.
 * Must be used within a component that's inside a Router context.
 */
export const useScrollTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top immediately when path changes
    window.scrollTo(0, 0);
    
    // Some browsers might need a small delay to properly scroll
    // especially when there's dynamic content loading
    const timeoutId = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
    
    return () => clearTimeout(timeoutId);
  }, [pathname]);

  return null;
};

/**
 * Component wrapper for useScrollTop hook
 * For backward compatibility
 */
const ScrollToTop = () => {
  useScrollTop();
  return null;
};

export default ScrollToTop;
